import { CmsApiThreeSectionSliderBlockData } from 'modules/cms/api/types/CmsApiThreeSectionSlider';
import { CmsAmpCardsBlock } from 'modules/cms/blocks/Amp/Cards';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpThreeSectionSliderBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiThreeSectionSliderBlockData>) {
  return (
    <CmsAmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.headline,
        // @ts-expect-error fix me
        imageSize: data.imageSize,
        cards: data.sections.map((section) => ({
          text: section.content,
          image: section.image,
        })),
      }}
    />
  );
}
